(() => {
  const PREFIX = 'JRMVariantDescriptionData-';
  const KEY = '__JRMVariantDescriptionControllersV1';

  const controllers = window[KEY] instanceof Map
    ? window[KEY]
    : new Map();
  window[KEY] = controllers;

  function parseData(root) {
    try {
      return JSON.parse(root.textContent || '{}');
    } catch (error) {
      console.error('JRM Variant Description: invalid JSON', error);
      return null;
    }
  }

  function appendPlainParagraph(target, text, srHeadingHtml = '') {
    target.innerHTML = srHeadingHtml;

    const paragraph = document.createElement('p');
    const lines = String(text || '').split(/\r?\n/);

    lines.forEach((line, index) => {
      if (index > 0) paragraph.append(document.createElement('br'));
      paragraph.append(document.createTextNode(line));
    });

    target.append(paragraph);
  }

  function make(dataRoot) {
    const data = parseData(dataRoot);
    if (!data || !data.variants || typeof data.variants !== 'object') return null;

    const section = dataRoot.closest('.shopify-section') || document;
    const readMore = section.querySelector('product-description.hdt-main-product-description');
    const target = readMore?.querySelector('.hdt-full-des')
      || section.querySelector('.hdt-product__description .hdt-rte');

    if (!target) return null;

    const fallbackHtml = target.innerHTML;
    const srHeadingHtml = readMore
      ? (target.querySelector('.sr-only')?.outerHTML || '')
      : '';
    const variants = data.variants;

    function refreshReadMore() {
      if (!readMore) return;

      requestAnimationFrame(() => {
        const content = readMore.querySelector('[data-content]');
        const button = readMore.querySelector('[data-button]');
        const overlay = content?.querySelector('.hdt-description-overlay');
        const limit = Number.parseInt(readMore.dataset.heightLimit || '', 10);

        if (!content || !button || !Number.isFinite(limit) || limit <= 0) return;

        readMore.classList.remove('is--less');
        content.style.setProperty('max-height', `${limit}px`);
        content.style.setProperty('--max-height', `${limit}px`);
        content.style.removeProperty('--height');

        const fullHeight = content.scrollHeight;
        content.style.setProperty('--height', `${fullHeight}px`);

        const needsReadMore = fullHeight > limit + 1;
        if (needsReadMore) {
          button.style.removeProperty('display');
          overlay?.style.removeProperty('display');
        } else {
          button.style.setProperty('display', 'none');
          overlay?.style.setProperty('display', 'none');
        }
      });
    }

    function restoreFallback() {
      target.innerHTML = fallbackHtml;
    }

    function render(variantId) {
      const key = variantId == null ? '' : String(variantId);
      const hasVariant = key && Object.prototype.hasOwnProperty.call(variants, key);
      const description = hasVariant ? variants[key] : '';

      if (typeof description === 'string' && description.trim() !== '') {
        appendPlainParagraph(target, description, srHeadingHtml);
      } else {
        restoreFallback();
      }

      refreshReadMore();
    }

    const controller = new AbortController();

    document.addEventListener('variant:change', event => {
      const variant = event.detail?.variant;
      if (!variant?.id) return;

      const key = String(variant.id);
      if (!Object.prototype.hasOwnProperty.call(variants, key)) return;

      render(key);
    }, { signal: controller.signal });

    render(data.initialVariantId ?? null);

    return {
      root: dataRoot,
      destroy() {
        controller.abort();
      }
    };
  }

  function initRoot(dataRoot) {
    const id = dataRoot.id;
    if (!id) return;

    const existing = controllers.get(id);
    if (existing?.root === dataRoot) return;

    existing?.destroy?.();
    controllers.delete(id);

    const controller = make(dataRoot);
    if (controller) controllers.set(id, controller);
  }

  function initWithin(scope) {
    if (!scope?.querySelectorAll) return;

    if (scope.matches?.(`script[id^="${PREFIX}"]`)) initRoot(scope);
    scope.querySelectorAll(`script[id^="${PREFIX}"]`).forEach(initRoot);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', event => {
    requestAnimationFrame(() => initWithin(event.target));
  });
})();
